import { render } from "./AiReportTopContainer.vue?vue&type=template&id=af0f96ee&scoped=true&ts=true"
import script from "./AiReportTopContainer.vue?vue&type=script&lang=ts"
export * from "./AiReportTopContainer.vue?vue&type=script&lang=ts"

import "./AiReportTopContainer.vue?vue&type=style&index=0&id=af0f96ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af0f96ee"]])

export default __exports__